// src/components/cookies/CookieFloatingButton.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import CookieIcon from "@mui/icons-material/Cookie";
import useSectionDarkMode from "../../hooks/useSectionDarkMode";

const CookieFloatingButton = ({ onClick }) => {
  const { t } = useTranslation();
  const darkMode = useSectionDarkMode("bottom");

  return (
    <button
      onClick={onClick}
      aria-label={t("cookies.manage")}
      className={`
        fixed bottom-5 left-5 z-[900]
        w-12 h-12 rounded-full
        flex items-center justify-center
        backdrop-blur-[30px]
        transition-all duration-300
        shadow-lg
        hover:scale-105 active:scale-95
        ${darkMode ? "bg-white/20 text-neutral-13" : "bg-white/20 text-neutral-1"}
      `}
    >
      <CookieIcon
        className={`
          text-[22px]
          transition-colors
          ${
            darkMode
              ? "text-black"
              : "text-white"
          }
        `}
      />
    </button>
  );
};

export default CookieFloatingButton;
